import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUser } from '../../config/token';
import Insurances from '../insurances/Insurances';

export default function RoleBasedHome() {
  const user = getUser();
  const router = useNavigate();

  useEffect(() => {
    if (user?.role === 'admin') {
      router('/management');
    }
  }, [user, router]);

  // Show Insurances for client users, redirect for admins
  return user?.role === 'admin' ? null : <Insurances />;
}
